module.exports = __webpack_public_path__ + "img/analysis.a9ffc818.png";